import React from "react";
import Grid from "@mui/material/Unstable_Grid2"; // Grid version 2
import { Link, TextField, Button, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { FormControl, InputLabel, MenuItem, Modal } from "@mui/material";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import "./TrendingQuestions.scss";
import RKTextField from "../../../../Supporting files/RKTextField/RKTextField";
import SelectDropdown from "../../../../Supporting files/SelectDropdown/SelectDropdown";
import SlidingPanel from "react-sliding-side-panel";

interface Props {
  attrName: any;
  open_status: boolean;
  value_update: Function;
}

const TrendingQuestions: React.FC<Props> = ({
  open_status,
  attrName,
  value_update,
}) => {
  const [addtrendingQuestions, setTrendingQuestions] = React.useState(false);
  var questions_data_origional = [
    {
      logo: "https://devpos.masuraksha.com/agent_documents/8708430006_Profile_Image_2022_04_14_16_51_17.png",
      username: "Umesh Gemini",
      question:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
      date: "22, August, 2022",
      upvotes: "2",
      answer_open_status: false,
      answerShowStatus: false,
    },
    {
      logo: "https://devpos.masuraksha.com/agent_documents/8708430006_Profile_Image_2022_04_14_16_51_17.png",
      username: "Umesh Gemini",
      question:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
      date: "22, August, 2022",
      upvotes: "2",
      answer_open_status: false,
      answerShowStatus: false,
    },
  ];

  var answer_one_data = [
    {
      logo: "https://devpos.masuraksha.com/agent_documents/8708430006_Profile_Image_2022_04_14_16_51_17.png",
      username: "Rahul Kumar",
      date: "02, August, 2022",
      answer:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt",
      upvotes: "10000",
    },
    {
      logo: "https://devpos.masuraksha.com/agent_documents/8708430006_Profile_Image_2022_04_14_16_51_17.png",
      username: "Rahul Kumar",
      date: "02, August, 2022",
      answer:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt",
      upvotes: "10000",
    },
    {
      logo: "https://devpos.masuraksha.com/agent_documents/8708430006_Profile_Image_2022_04_14_16_51_17.png",
      username: "Rahul Kumar",
      date: "02, August, 2022",
      answer:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt",
      upvotes: "10000",
    },
  ];
  var answer_two_data = [
    {
      logo: "https://devpos.masuraksha.com/agent_documents/8708430006_Profile_Image_2022_04_14_16_51_17.png",
      username: "Rahul Kumar",
      date: "02, August, 2022",
      answer:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt",
      upvotes: "10000",
    },
    {
      logo: "https://devpos.masuraksha.com/agent_documents/8708430006_Profile_Image_2022_04_14_16_51_17.png",
      username: "Rahul Kumar",
      date: "02, August, 2022",
      answer:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt",
      upvotes: "10000",
    },
    {
      logo: "https://devpos.masuraksha.com/agent_documents/8708430006_Profile_Image_2022_04_14_16_51_17.png",
      username: "Rahul Kumar",
      date: "02, August, 2022",
      answer:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt",
      upvotes: "10000",
    },
  ];

  function updateMasterState(attrName: any, value: any) {
    attrName(value);
  }
  const [questions, setQuestions] = React.useState(questions_data_origional);
  const [answerOpenOneStatus, setAnswerOpenOneStatus] = React.useState(false);
  const [answerOpenTwoStatus, setAnswerOpenTwoStatus] = React.useState(false);
  const [newQues, setNewQues] = React.useState("");
  const [pageStatus, setPageStatus] = React.useState<number>(1);
  const answer_open_status_changes = (index: number) => {
    if (index == 0) {
      setAnswerOpenOneStatus(!answerOpenOneStatus);
    } else {
      setAnswerOpenTwoStatus(!answerOpenTwoStatus);
    }
  };

  const changePageStatus = (status: boolean) => {
    if (status === true) {
      if (pageStatus < 2) {
        setPageStatus(pageStatus + 1);
      }
    } else {
      if (pageStatus > 1) {
        setPageStatus(pageStatus - 1);
      }
    }
  };
  return (
    <Grid
      container
      alignItems="center"
      spacing={3}
      className="trendingQuestions"
    >
      <Grid xs={6}>
        <h3 className="mb-0">Trending Questions </h3>
      </Grid>
      <Grid xs={6} className="text-right">
        <Link
          className="greenBtn addfile"
          underline="none"
          onClick={() => {
            setTrendingQuestions(true);
          }}
        >
          Post a query
        </Link>
        {/* <Modal open={addtrendingQuestions} className="modalWrapper">
          <Box className="modalInner">
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Link
                  
                  className="close-button"
                  onClick={() => {
                    setTrendingQuestions(false);
                  }}
                />
                <h5 className="popup-heading">What’s on your mind</h5>
              </Grid>
            </Grid>
            <Grid
              container
              spacing={2}
              justifyContent="center"
              className="mb-4"
              >
              <Grid item xs={12}>
                {/* <TextField
                  fullWidth
                  id="outlined-basic"
                  label="Write your question here"
                  variant="outlined"
                /> */}
        {/* <RKTextField
                  class_name="inputField"
                  title="Write your question here"
                  value={newQues}
                  value_update={updateMasterState}
                  attrName={setNewQues}
                  warn_status={false}
                />
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid
                item
                xs={12}
                className="ctaBtn"
                style={{ textAlign: "center" }}
              >
                <Button variant="contained" className="submitBtn">
                  Post Query
                </Button>
              </Grid>
            </Grid>
          </Box> 
        </Modal>*/}
        <SlidingPanel
          type={"right"}
          isOpen={addtrendingQuestions}
          size={75}
          panelClassName="slidingPanel"
          backdropClicked={() => setTrendingQuestions(false)}
        >
          <Box
            className={open_status == true ? "modalInner show" : "modalInner"}
          >
            {pageStatus == 5 ? null : (
              <Grid container spacing={3} alignItems="center">
                <Grid xs={6}>
                  <h4 className="mb-0 mt-3 text-left">What’s on your mind</h4>
                </Grid>
              </Grid>
            )}
            {pageStatus == 2 ? null : (
              <div className="scrollable_area">
                <Grid container spacing={3}>
                  <Grid xs={12}>
                    <Typography>
                      <Grid
                        container
                        spacing={2}
                        justifyContent="center"
                        sx={{ padding: "0px" }}
                      >
                        <Grid xs={12}>
                          <RKTextField
                            class_name="inputField"
                            title="Write your question here"
                            value={newQues}
                            attrName={setNewQues}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>
                    </Typography>
                  </Grid>
                </Grid>
              </div>
            )}

            {pageStatus == 2 ? (
              <Grid container spacing={2}>
                <Grid xs={12} className="tick_animation">
                  <svg
                    className="checkmark"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 52 52"
                  >
                    <circle
                      className="checkmark__circle"
                      cx="26"
                      cy="26"
                      r="25"
                      fill="none"
                    />
                    <path
                      className="checkmark__check"
                      fill="none"
                      d="M14.1 27.2l7.1 7.2 16.7-16.8"
                    />
                  </svg>
                  <p className="quote_success">
                    New Question has been added successfully!
                  </p>
                </Grid>
              </Grid>
            ) : null}
            <Grid container spacing={2}>
              {pageStatus == 2 ? null : (
                <Grid
                  xs={12}
                  style={{ textAlign: "center", position: "relative" }}
                  className="ctaBtn"
                >
                  <Button
                    variant="contained"
                    className="submitBtn fixedbtn"
                    onClick={() => {
                      changePageStatus(true);
                    }}
                  >
                    {pageStatus == 1 ? "Post Query" : "Continue"}
                  </Button>
                </Grid>
              )}
            </Grid>
          </Box>
        </SlidingPanel>
      </Grid>
      <Grid xs={12}>
        {questions.map((data, index) => {
          return (
            <Box className="questionPost">
              <Grid container spacing={2}>
                <Grid xs={12} className="postTitle">
                  <div className="userIcon">
                    <img src={data.logo} />
                  </div>
                  <div className="userName">
                    <h6>{data.username}</h6>
                    <p>{data.date}</p>
                  </div>
                </Grid>
                <Grid xs={12}>
                  <p className="question">{data.question}</p>
                </Grid>
                <Grid xs={12} className="greySection">
                  <Grid container spacing={2}>
                    <Grid xs={12}>
                      <Link className="upvote active" underline="none">
                        {data.upvotes} upvotes
                      </Link>
                      <Link
                        className="answer"
                        underline="none"
                        onClick={() => {
                          answer_open_status_changes(index);
                        }}
                      >
                        {index == 0
                          ? answer_one_data.length
                          : answer_two_data.length}
                        answers
                      </Link>
                    </Grid>
                  </Grid>
                  {index == 0 ? (
                    answerOpenOneStatus == true ? (
                      <Box className="postGroup">
                        <TextField
                          fullWidth
                          id="outlined-basic"
                          placeholder="Add answer"
                        />
                        <Button>Post</Button>
                      </Box>
                    ) : null
                  ) : null}
                  {index == 1 ? (
                    answerOpenTwoStatus == true ? (
                      <Box className="postGroup">
                        <TextField
                          fullWidth
                          id="outlined-basic"
                          placeholder="Add answer"
                        />
                        <Button>Post</Button>
                      </Box>
                    ) : null
                  ) : null}
                  {index == 0
                    ? answerOpenOneStatus == true
                      ? answer_one_data.map((dataAns, indexAns) => {
                          return (
                            <div>
                              <Grid container spacing={2} className="innerPost">
                                <Grid xs={12} className="postTitle">
                                  <div className="userIcon">
                                    <img src={dataAns.logo} />
                                  </div>
                                  <div className="userName">
                                    <h6>{dataAns.username}</h6>
                                    <p>{dataAns.date}</p>
                                  </div>
                                </Grid>
                                <Grid xs={12}>
                                  <p className="question">{dataAns.answer}</p>
                                </Grid>
                                <Grid xs={12}>
                                  <Link
                                    className="upvote active"
                                    underline="none"
                                  >
                                    {dataAns.upvotes} upvotes
                                  </Link>
                                </Grid>
                              </Grid>
                            </div>
                          );
                        })
                      : null
                    : null}
                  {index == 1
                    ? answerOpenTwoStatus == true
                      ? answer_two_data.map((dataAns, indexAns) => {
                          return (
                            <div>
                              <Grid container spacing={2} className="innerPost">
                                <Grid xs={12} className="postTitle">
                                  <div className="userIcon">
                                    <img src={dataAns.logo} />
                                  </div>
                                  <div className="userName">
                                    <h6>{dataAns.username}</h6>
                                    <p>{dataAns.date}</p>
                                  </div>
                                </Grid>
                                <Grid xs={12}>
                                  <p className="question">{dataAns.answer}</p>
                                </Grid>
                                <Grid xs={12}>
                                  <Link
                                    className="upvote active"
                                    underline="none"
                                  >
                                    {dataAns.upvotes} upvotes
                                  </Link>
                                </Grid>
                              </Grid>
                            </div>
                          );
                        })
                      : null
                    : null}
                </Grid>
              </Grid>
            </Box>
          );
        })}
      </Grid>
    </Grid>
  );
};

export default TrendingQuestions;
